import React from "react"
import PropTypes from "prop-types"
import {
  Col,
  Row,
  Button,
} from "reactstrap"
import EstimateCostBlock from "./EstimateCostBlock"

const Step4EstimateCost = ({ pageView, validation, onBack, onCancel, onSaveDraft, onConfirm }) => {
  const estimateData = {
    unit: validation.values.estimateCostUnit || "RMB",
    filterFee: validation.values.estimateCostFee || "0.00",
    basicRewards: validation.values.estimateCostBasicRewards || "0.00",
    addOnRewards: validation.values.estimateCostAddOnRewards || "0.00",
    totalRewards: validation.values.estimateCostTotalRewards || "0.00",
    managementFee: validation.values.estimateCostManagementFee || "0.00",
    totalEstimateFee: validation.values.estimateCostTotal || "0.00",
  }

  const handleUnitChange = (e) => {
    console.log("Unit changed:", e.target.value)
    // TODO: Handle unit change
  }

  return (
    <>
      {/* Block: Estimate Cost */}
      <Row>
        <Col>
          <EstimateCostBlock 
            mode="view" 
            data={estimateData}
            onUnitChange={handleUnitChange}
          />
        </Col>
      </Row>

      {/* Action Buttons */}
      <Row className="mt-4">
        <Col style={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left Side: Back, Cancel */}
          <div className="d-flex gap-2">
            <Button
              type="button"
              outline
              color="secondary"
              style={{ minWidth: "120px" }}
              onClick={onBack}
            >
              <i className="bx bx-arrow-back me-1"></i>
              Back
            </Button>
            {pageView === "update" && (
              <Button
                type="button"
                outline
                color="secondary"
                style={{ minWidth: "120px" }}
                onClick={onCancel}
              >
                <i className="bx bx-x me-1"></i>
                Cancel
              </Button>
            )}
          </div>

          {/* Right Side: Save Draft, Confirm */}
          <div className="d-flex gap-2">
            <Button
              type="button"
              style={{
                backgroundColor: "#fff",
                border: "1px solid #34c38f",
                color: "#34c38f",
                minWidth: "120px",
              }}
              onClick={onSaveDraft}
            >
              <i className="bx bx-save me-1"></i>
              Save Draft
            </Button>
            <Button
              type="button"
              color="success"
              style={{ minWidth: "120px" }}
              onClick={onConfirm}
            >
              <i className="bx bx-check me-1"></i>
              Confirm
            </Button>
          </div>
        </Col>
      </Row>
    </>
  )
}

Step4EstimateCost.propTypes = {
  pageView: PropTypes.string,
  onBack: PropTypes.func,
  onCancel: PropTypes.func,
  onSaveDraft: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default Step4EstimateCost
